// src/components/DisclaimerSheet.tsx
// Shows once on first visit (tracked via localStorage).
// Mount this once in App.tsx or in your root layout.

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "ms_disclaimer_seen";

export default function DisclaimerSheet() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) {
      // Small delay so it feels intentional, not instant
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="disclaimer-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={dismiss}
          style={{
            position: "fixed", inset: 0, zIndex: 9999,
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(4px)",
            display: "flex", alignItems: "flex-end", justifyContent: "center",
          }}
        >
          <motion.div
            key="disclaimer-sheet"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 320, damping: 34 }}
            onClick={e => e.stopPropagation()}
            style={{
              width: "100%", maxWidth: 560,
              background: "#FFFFFF",
              borderRadius: "20px 20px 0 0",
              padding: "26px 26px 40px",
              boxShadow: "0 -10px 48px rgba(0,0,0,0.18)",
            }}
          >
            {/* Handle bar */}
            <div style={{
              width: 38, height: 4, borderRadius: 2,
              background: "#E5E7EB", margin: "0 auto 22px",
            }} />

            <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
              <img
                src="https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/27/ce/94/27ce94bc-3a2b-f91e-1671-b47b91b36e7c/AppIcon-prod-0-0-1x_U007emarketing-0-11-0-85-220.png/400x400ia-75.webp"
                alt="Official MySatsang app icon"
                style={{
                  width: 54, height: 54, borderRadius: 14, flexShrink: 0,
                  border: "1px solid #E5E7EB", objectFit: "cover",
                }}
              />
              <div>
                <p style={{
                  fontSize: 11, fontWeight: 700,
                  letterSpacing: "0.08em", textTransform: "uppercase",
                  color: "#D97706", margin: "0 0 7px",
                }}>
                  About this site
                </p>
                <p style={{
                  fontSize: 15, lineHeight: 1.65,
                  color: "#1C1C1E", margin: 0,
                }}>
                  <strong>This is not the official MySatsang app.</strong>{" "}
                  It was built personally for note-taking and spiritual study —
                  you're welcome to use it freely.
                </p>
                <a
                  href="https://apps.apple.com/ca/app/mysatsang/id6444313821"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block", marginTop: 10,
                    fontSize: 13, color: "#0F6E56", fontWeight: 600,
                    textDecoration: "none",
                    borderBottom: "1px solid #0F6E56", paddingBottom: 1,
                  }}
                >
                  View official app on App Store →
                </a>
              </div>
            </div>

            <button
              onClick={dismiss}
              style={{
                marginTop: 24, width: "100%",
                background: "#0F0F0F", color: "#FFFFFF",
                border: "none", borderRadius: 12,
                padding: "14px 0", fontSize: 15, fontWeight: 600,
                cursor: "pointer", fontFamily: "inherit",
                letterSpacing: "0.01em",
              }}
            >
              Got it, continue
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}